import React from "react";
import './password-strength-meter.css'
import {makeStyles} from "@material-ui/core/styles";
import {Check} from '@material-ui/icons'

const useStyles = makeStyles(theme => ({
    hintList: {
        listStyle: 'disc outside none',
        padding: '10px 10px 10px 25px',
    },
}));

const PasswordStrengthMeter = ({check, variant = 'minimal'}) => {
    // console.log('PasswordStrengthMeter', variant);
    return (
        <div className="password-strength-meter">
            <Meter value={check.score}/>
            { variant === 'full' ? <Hints check={check} /> : null }
        </div>
    )
}

const Meter = ({value = 0}) => {
    return (
        <progress
            className={`password-strength-meter-progress strength-${value}`}
            value={value} max="4"
        />
    )
}

const Hints = ({check = {warning:'', suggestions:[]}}) => {
    const classes = useStyles();
    return (
        <div style={{minHeight: 120, backgroundColor: '#eee', borderRadius: 4, padding: 8} }>
            { check.warning.length  > 0 ?
                <div>{check.warning}</div>
                : null
            }
            { check.warning.length === 0 && check.suggestions.length === 0 ?
                <div className="flex flex-grow justify-center mt-10">
                    <p><Check fontSize="small" style={{color: 'green'}}/> You can use this password</p>
                </div>
                : null
            }
            <ul className={classes.hintList}>
                { check.suggestions.map((s, index) => (
                    <li key={index}>{s}</li>
                ))}
            </ul>
        </div>
    )
}

export default PasswordStrengthMeter;
